import { render, staticRenderFns } from "./BookingFieldOpportunityTypes.vue?vue&type=template&id=5cfb1d3c&scoped=true"
import script from "./BookingFieldOpportunityTypes.vue?vue&type=script&lang=js"
export * from "./BookingFieldOpportunityTypes.vue?vue&type=script&lang=js"
import style0 from "./BookingFieldOpportunityTypes.vue?vue&type=style&index=0&id=5cfb1d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb1d3c",
  null
  
)

export default component.exports